import { render } from "./FramesSizes.vue?vue&type=template&id=7eb2ffac&scoped=true"
import script from "./FramesSizes.vue?vue&type=script&lang=js"
export * from "./FramesSizes.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=7eb2ffac&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb2ffac"]])

export default __exports__